import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: #ffffff;\n  font-size: 12px;\n  background: #000000;\n  width: fit-content;\n  padding: 6px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  opacity: 0.8;\n  transform: translate(-40%, -140%);\n  white-space: nowrap;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        font-size: 12px;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      top: 15px;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import { Range } from "rc-slider";
export var customSliderStyles = "&.rc-slider {\n  height: 16px;\n  margin-bottom: 16px;\n}\n.rc-slider {\n  &-rail {\n    background-color: #c5ced3;\n    height: 1px;\n    transform: translateY(50%);\n  }\n  &-track {\n    background-color: #4f6e7c;\n    height: 1px;\n    transform: translateY(50%);\n  }\n  &-step {\n    height: 1px;\n  }\n  &-dot {\n    margin-left: -1px;\n    border-radius: 1px;\n    width: 2px;\n    height: 6px;\n    border: none;\n    bottom: -3px;\n    background-color: #c5ced3;\n    &-active {\n      background-color: #4f6e7c;\n    }\n  }\n  &-handle {\n    width: 16px;\n    height: 16px;\n    bottom: 2px;\n    background: #81a0ae;\n    border: 6px solid #4f6e7c;\n    &-click-focused,\n    &:hover,\n    &:focus {\n      border-color: #4f6e7c;\n    }\n    &-dragging {\n      width: 18px;\n      height: 18px;\n      bottom: 1px;\n      &.rc-slider-handle-dragging.rc-slider-handle-dragging {\n        border-color: #4f6e7c;\n        box-shadow: none;\n      }\n    }\n    .c-tooltip {\n      color: #ffffff;\n      background: #000000;\n      width: fit-content;\n      padding: 4px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 6px;\n      opacity: 0.8;\n      transform: translate(-40%,-140%);\n    }\n  }\n  &-mark {\n    display: flex;\n    justify-content: space-between;\n    top: 17px;\n    ".concat(media.xxxLargeScreen(_templateObject()), "\n    &-text,\n    &-text-active {\n      color: #839098;\n      white-space: nowrap;\n      position: relative;\n      font-size: 16px;\n      ").concat(media.xxxLargeScreen(_templateObject2()), "\n    }\n  }\n}");
export var StyledRange = styled(Range)(_templateObject3(), customSliderStyles);
export var StyledTooltip = styled.div(_templateObject4());